export default __webpack_public_path__ + "static/media/sprite.c6e3308b.svg";